import { render, staticRenderFns } from "./MemoInfo2.vue?vue&type=template&id=43ff1845&scoped=true"
import script from "./MemoInfo2.vue?vue&type=script&lang=js"
export * from "./MemoInfo2.vue?vue&type=script&lang=js"
import style0 from "./MemoInfo2.vue?vue&type=style&index=0&id=43ff1845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff1845",
  null
  
)

export default component.exports